import React, {Component} from 'react';
import DisallowChecking from './disallow-checking';
import PositionsGroup from './positions-group';

class DisallowedPositions extends Component {
    render() {
        return (
            <div className="form-inline">
                <DisallowChecking />
                <PositionsGroup groupNumber={1} />
                <div className="form-sub-text">from Primary Stack and</div>
                <PositionsGroup groupNumber={2} />
                <div className="form-sub-text">from Secondary Stack</div>
            </div>
        );
    }
}

export default DisallowedPositions;
